<template>
<div>
  <breadcrumb :items="[{ text: 'Ofertas', active: true }]" />
  <router-link class="btn btn-primary btn-add" to="/cadastrar-oferta"><i class="fa fa-plus"></i> Cadastrar oferta</router-link>
  <div class="filters">
    <b-form-input v-model="filters.search" type="search" class="form-control" placeholder="Buscar..." @input="showFilterButtom = true" @keyup.enter="list" />
    <b-button v-if="showFilterButtom" variant="primary" block size="sm" @click="list">
      Filtrar
    </b-button>
    <br>
  </div>
  <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
  <loading :loading="!offers && !error" msg="Carregando lista de ofertas" />
  <no-item :list="offers" />
  <div v-if="offers && offers.length">
    <table class="table b-table b-table-stacked-lg">
      <thead>
        <tr>
          <th></th>
          <th>Oferta</th>
          <th>Origem do envio</th>
          <th>Data de fabricação</th>
          <th>Preço final</th>
          <th>Disponível</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="offer in offers" :key="offer._id">
          <td class="td-logo">
            <router-link :to="'/editar-oferta/'+ offer._id" class="product_td">
              <product-image :product="offer.product_variation" :product_variation="offer.product_variation" />
            </router-link>
          </td>
          <td>
            <router-link :to="'/editar-oferta/'+ offer._id" class="product_td">
              {{offer.product_variation.name}}
            </router-link>
          </td>
          <td>
            <div v-if="offer.manufacturing_date">
              {{offer.manufacturing_date | moment("DD/MM/YYYY")}}
            </div>
            <div v-if="offer.product_variation && offer.product_variation.duration && offer.product_variation.duration.value && offer.manufacturing_date">
              <small>Vence {{offer.manufacturing_date | moment("add", offer.product_variation.duration.value + ' ' + date_unit[offer.product_variation.duration.unit]) | moment('from', 'now')}}</small>
            </div>
          </td>
          <td>
            <small v-if="offer.address">{{offer.address.description}}</small>
          </td>
          <td>
            {{offer.final_price | moeda}}
          </td>
          <td>
            {{offer.qtd - offer.qtd_ordered}} unidades
          </td>
          <td>
            <div class="btn-group btn-group-sm">
              <router-link :to="'/editar-oferta/'+ offer._id" class="btn btn-primary">
                <i class="fa fa-pencil"></i>
              </router-link>
              <a @click="remove(offer._id)" class="btn btn-secondary">
                <i class="fa fa-close"></i>
              </a>
            </div>
            <button class="btn btn-default btn-sm" @click="createColectiveOffer(offer._id)">
              <i class="fa fa-plus"></i>
              Oferta Coletiva
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
</template>
<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import NoItem from '@/components/NoItem'
import ProductImage from '@/components/ProductImage'

export default {

  name: 'Offers',

  data() {
    return {
      showFilterButtom: false,
      filters: {
        search: null
      },
      offers: null
    }
  },

  created() {
    this.list()
    this.table_fields.push({
      key: 'actions',
      label: '',
      'class': 'td-actions'
    })
  },

  methods: {
    async list() {
      axios.get('offers', {
        params: {
          search: this.filters.search,
          populate: 'product_variation supplier organization'
        }
      }).then(response => {
        this.offers = response.data
      }).catch(this.showError)

    },
    createColectiveOffer(offerId) {
      axios.post('collective_offers',{
        params: {
          offerId: offerId
        }
      }).then(response => {
        this.$router.replace('editar-oferta-coletiva/' + response.data._id)
      })
    },
    remove(id) {
      if (confirm("Tem certeza que deseja excluír?")) {
        axios.delete('offers/' + id).then(() => {
          this.list()
        }).catch(this.showError)
      }
    }
  },
  components: {
    Loading,
    NoItem,
    ProductImage
  }

};
</script>
